module.exports = __webpack_public_path__ + "img/foaming_1200x800.b53fd6cf.svg";